import ModalConfirm from "elements/modalConfirm";
import { common } from "helpers";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// includes
import AgTable from "elements/AgTable";
import { api } from "helpers";

function CashbackRequestList() {
  // init
  const navigate = useNavigate();
  // state
  const [permission] = useState(common.getUserPermission());
  // effect
  useEffect(() => {
    if (!permission.includes("cqr")) {
      navigate("/profile");
    }
  }, []);
  // function
  const callAction = (data) => {
    if (data.type == "View") {
      navigate("/cashbackrequest/view/" + data.item._id);
    }
  };

  return (
    permission.includes("cqr") && (
      <AgTable
        module="adminCashbackRequest"
        filterData={{
          studentSingle: { key: "studentId", value: "" },
          approved: { key: "isApproved", value: ""}
        }}
        onAction={(data) => callAction(data)}
        actionPermission={common.accessTable(permission, [
          "cqc",
          "cqu",
          "cqr",
          "cqd",
        ])}
      />
    )
  );
}

export default CashbackRequestList;
